<script setup lang="ts">
interface Props {
  author: ProductQuestion['title'];
  body: ProductQuestion['text'];
  publishedDate: ProductQuestion['createdAt'];
  answers?: ProductQuestionAnswers;
}

const store = useStore()
const { shopInformation } = storeToRefs(store)

const { author, body, publishedDate, answers = [] } = defineProps<Props>()

const localePublishedDate = useLocaleDate(new Date(publishedDate))

const answerAuthor = computed<string>(() => shopInformation.value.shopInformation.shopName)
</script>

<template>
  <div>
    <div class="border-b border-gray-400 mb-[15px]">
      <div class="flex pb-[15px]">
        <div class="flex-auto w-4/6">
          <span class="block text-primary text-16 font-medium capitalize">#{{ author }}</span>
          <span>{{ localePublishedDate }}</span>
        </div>
      </div>
      <p class="pb-[9.5px]">
        {{ body }}
      </p>
    </div>
    <FaqAnswer v-for="answer in answers" :key="answer.id" :author="answerAuthor" :published-date="answer.createdAt" :body="answer.text" />
  </div>
</template>
